import { AnyAction } from 'redux';
import { opApiRequest } from 'src/api/apiRequest';
import endpoints from 'src/api/opEndpoints';
import apiTypes from 'src/api/optimalprint-sdk.d';
import sendSetDesignDataPostMessageOperation from 'src/store/app/operation/sendSetDesignDataPostMessageOperation';
import addCustomerDesignOperation from 'src/store/design/operation/addCustomerDesignOperation';
import { DesignData } from 'src/store/design/types';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';
import {
  setDesignIsLoadingAction,
  setDesignEncPublicIdAction,
  setDesignProductTypeIdAction,
  setDesignCategoryIdAction,
  setDesignQuantityAction,
  setDesignProductUidAction,
  setDesignIdAction,
  setDesignIsPublicAction,
  setDesignProductIdAction,
  setDesignStructureAction,
  setDesignTotalPagesCountAction,
} from 'src/store/design/slice';
import getQuantityFromUrl from 'src/util/url/getQuantityFromUrl';
import removeUnsupportedPrintAreas from 'src/util/design/removeUnsupportedPrintAreas';

const fetchPublicDesignOperation = () => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
) => {
  const {
    isPublicDesign, encPublicDesignId, categoryId, quantity,
  } = useIntegrationLayer();

  if (!isPublicDesign) {
    return;
  }

  dispatch(setDesignIsLoadingAction(true));

  let response;

  try {
    response = (await opApiRequest(
      endpoints.PUBLIC_DESIGN_V3_GET,
      {
        encPublicDesignId,
      },
      'data',
      'GET',
    )) as apiTypes.AppBundle.Api.Response.Design.V3.DesignPublicGetV3Response;
    if (!response) {
      // eslint-disable-next-line no-console
      console.error('Cannot fetch public design');
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Cannot fetch public design, exception: ', e);
  }

  if (response) {
    const {
      designId, productTypeId, productId, productUid,
    } = response;

    const designStructure = removeUnsupportedPrintAreas(
      response.designStructure as unknown as DesignData,
    );

    dispatch(setDesignIsPublicAction(true));
    dispatch(setDesignEncPublicIdAction(encPublicDesignId));
    dispatch(setDesignIdAction(designId));
    dispatch(setDesignStructureAction(designStructure));
    dispatch(setDesignProductTypeIdAction(productTypeId));
    dispatch(setDesignProductIdAction(productId));
    dispatch(setDesignProductUidAction(productUid));
    dispatch(setDesignCategoryIdAction(categoryId));
    dispatch(setDesignQuantityAction(getQuantityFromUrl() || quantity));
    const totalPagesCount = designStructure.page_count;
    dispatch(setDesignTotalPagesCountAction(totalPagesCount));
    await dispatch(addCustomerDesignOperation(categoryId, productTypeId, designStructure, encPublicDesignId));
    dispatch(sendSetDesignDataPostMessageOperation(designStructure));
  }
  dispatch(setDesignIsLoadingAction(false));
};

export default fetchPublicDesignOperation;
